import Listing from '../../services/Listing';

export default {
    namespaced: false,
    state: {
        categories: [],
        attributes: {},
        filteredAttributes: {
            pa_brand: [],
            pa_color: [],
            pa_material: [],
            pa_size: []
        },
        attrShow: [],
        products: [],
        ids: [],
        isLastPage: false,
        currentPage: null,
        lastPage: null,
        user: 0
    },
    mutations: {
        SET_ATTRIBUTES(state, data) {
            state.attributes = data;
        },
        SET_CATEGORIES(state, data) {
            state.categories = data;
        },
        SET_ATTRSHOW(state, data) {
            state.attrShow = data;
        },
        SET_PRODUCTSLISTING(state, data) {
            state.products = data.products;
        },
        SET_USER(state, data) {
            state.user = data;
        },
        SET_IDS(state, data) {
            state.ids = data;
        },
        SET_FILTEREDATTRIBUTES(state, data) {
            state.filteredAttributes = data;
        },
        SET_LAST_PAGE(state, data) {
            state.lastPage = data;
        }
    },
    actions: {
        async fetchProducts({ commit, dispatch }, body) {
            const { type } = body;
            const res = type === 'pagination' ? await Listing.fetchPaginatedProducts(body) : await Listing.fetchInitialProducts(body);
            if (type === 'initial') {
                await commit('SET_IDS', res.ids);
                await dispatch('setLastPage', Math.ceil(res.ids.length / body.limit));
            }
            res?.usedAttrs && commit('SET_FILTEREDATTRIBUTES', res.usedAttrs);
            await dispatch('setPage', body.page);
            await commit('SET_PRODUCTSLISTING', {
                products: res.products
            });
        },
        resetProducts({ commit }) {
            commit('SET_PRODUCTSLISTING', { products: [] });
        },
        setProducts({ commit, dispatch }, data) {
            commit('SET_PRODUCTSLISTING', { products: data.products });
            dispatch('setPage', data.page);
            dispatch('setLastPage', data.lastPage);
        },
        setCategories({ commit }, data) {
            commit('SET_CATEGORIES', data);
        },
        setAttrShow({ commit }, data) {
            commit('SET_ATTRSHOW', data);
        },
        setAttributes({ commit }, data) {
            commit('SET_ATTRIBUTES', data);
        },
        setIds({ commit }, data) {
            commit('SET_IDS', data);
        },
        setFilteredAttributes({ commit }, data) {
            commit('SET_FILTEREDATTRIBUTES', data);
        }
    }
};
